import script from "./CandidateStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidateStatusBadge.vue?vue&type=script&setup=true&lang=js"

import "./CandidateStatusBadge.vue?vue&type=style&index=0&id=94f06e1c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94f06e1c"]])

export default __exports__